import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import EntrepriseCreation from "../../../components/Admin/Entreprise/EntrepriseCreation";
import EntreprisesVue from "../../../components/Admin/Entreprise/EntreprisesVue";
import UtilisateurCreation from "../../../components/Admin/Utilisateurs/UtilisateurCreation";
import UtilisateursCreationEnMasse from "../../../components/Admin/Utilisateurs/UtilisateursCreationEnMasse";
import UtilisateursVue from "../../../components/Admin/Utilisateurs/UtilisateursVue";

function AdminEntreprisesPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const modeOptions = {
        'creation': <EntrepriseCreation entreprise={null} />,
        'consultation': <EntreprisesVue mode={mode} />,
        'default': <EntreprisesVue mode={mode} />
    };
    const ComponentToRender = modeOptions[mode] || modeOptions['default'];

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    return ( ComponentToRender )
}

export default AdminEntreprisesPage;
